module.exports = __webpack_public_path__ + "img/collected.616d3b15.svg";